export default __webpack_public_path__ + "static/media/no_bannder.40ccc85f.jpg";